import { useState } from 'react';

const PAGE_SIZE = 25;

const MARKET_LABELS = { h2h: 'ML', spreads: 'Spread', totals: 'Total' };
const SPORT_LABELS = {
  americanfootball_nfl: 'NFL', americanfootball_ncaaf: 'NCAAF',
  basketball_nba: 'NBA', basketball_ncaab: 'NCAAB',
  baseball_mlb: 'MLB', icehockey_nhl: 'NHL', soccer_usa_mls: 'MLS',
  mma_mixed_martial_arts: 'MMA', boxing_boxing: 'Boxing',
};

const STATUS_STYLES = {
  won: 'text-[#029456]',
  lost: 'text-[#DC2626]',
  push: 'text-[#6B7280]',
  pending: 'text-[#F86A38]',
  void: 'text-[#6B7280]',
};

function fmtOdds(n) {
  if (n == null) return '?';
  return n > 0 ? `+${Math.round(n)}` : `${Math.round(n)}`;
}

export default function BetLog({ bets }) {
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(bets.length / PAGE_SIZE);
  const displayed = bets.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <div className="rounded-md border border-[#E5E7EB] dark:border-[#1e2536] bg-white dark:bg-[#151a25] overflow-x-auto">
      <div className="flex items-center justify-between px-3 py-2 border-b border-[#E5E7EB] dark:border-[#1e2536]">
        <div className="flex items-center gap-2">
          <div className="w-[3px] h-4 bg-[#005BB3] rounded-full" />
          <h3 className="text-[12px] uppercase tracking-[0.5px] font-semibold text-[#6B7280] dark:text-[#8892a8]" style={{ fontFamily: 'var(--font-sans)' }}>Bet Log</h3>
        </div>
        <span className="text-[12px] text-[#6B7280]" style={{ fontFamily: 'var(--font-mono)' }}>{bets.length} bet{bets.length !== 1 ? 's' : ''}</span>
      </div>

      {bets.length === 0 ? (
        <div className="text-center py-10">
          <p className="text-[#6B7280] text-sm" style={{ fontFamily: 'var(--font-sans)' }}>No bets yet.</p>
          <p className="text-[#6B7280] text-[12px] mt-1" style={{ fontFamily: 'var(--font-sans)' }}>Add your first bet to start tracking.</p>
        </div>
      ) : (
        <>
          <table className="w-full text-left min-w-[700px]">
            <thead>
              <tr className="text-[12px] uppercase tracking-[0.5px] text-[#6B7280] border-b border-[#E5E7EB] dark:border-[#1e2536]">
                <th className="py-2 px-3 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Date</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Sport</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Matchup</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Market</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Pick</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Odds</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Stake</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>Result</th>
                <th className="py-2 px-2 font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>P&L</th>
              </tr>
            </thead>
            <tbody>
              {displayed.map((b, i) => {
                const date = new Date(b.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                const pick = b.market === 'spreads' && b.point != null
                  ? `${b.selection} ${b.point > 0 ? '+' : ''}${b.point}`
                  : b.market === 'totals' && b.point != null
                  ? `${b.selection} ${b.point}`
                  : b.selection;
                const plColor = b.profit > 0 ? 'text-[#029456]' : b.profit < 0 ? 'text-[#DC2626]' : 'text-[#6B7280]';

                return (
                  <tr key={b.id || i} className="border-b border-[#E5E7EB] dark:border-[#1e2536] text-[13px]">
                    <td className="py-2 px-3 text-[#6B7280]" style={{ fontFamily: 'var(--font-mono)' }}>{date}</td>
                    <td className="py-2 px-2 text-[#6B7280]" style={{ fontFamily: 'var(--font-sans)' }}>{SPORT_LABELS[b.sport_key] || b.sport_key}</td>
                    <td className="py-2 px-2 text-[#111827] dark:text-[#e2e8f0] truncate max-w-[150px]" style={{ fontFamily: 'var(--font-sans)' }}>{b.away_team} @ {b.home_team}</td>
                    <td className="py-2 px-2">
                      <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-[#E8F0FE] dark:bg-[rgba(0,91,179,0.15)] text-[#005BB3] dark:text-[#3b82f6]">{MARKET_LABELS[b.market] || b.market}</span>
                    </td>
                    <td className="py-2 px-2 text-[#111827] dark:text-[#e2e8f0]" style={{ fontFamily: 'var(--font-sans)' }}>{pick}</td>
                    <td className="py-2 px-2 text-[#1F2937] dark:text-[#e2e8f0]" style={{ fontFamily: 'var(--font-mono)' }}>{fmtOdds(b.odds)}</td>
                    <td className="py-2 px-2 text-[#1F2937] dark:text-[#e2e8f0]" style={{ fontFamily: 'var(--font-mono)' }}>${b.stake}</td>
                    <td className={`py-2 px-2 font-semibold ${STATUS_STYLES[b.status] || 'text-[#6B7280]'}`} style={{ fontFamily: 'var(--font-mono)' }}>
                      {b.status?.toUpperCase()}
                    </td>
                    <td className={`py-2 px-2 font-semibold ${plColor}`} style={{ fontFamily: 'var(--font-mono)' }}>
                      {b.profit != null ? `${b.profit >= 0 ? '+' : ''}${b.profit.toFixed(2)}` : '--'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div className="flex items-center justify-center gap-2 py-2 border-t border-[#E5E7EB] dark:border-[#1e2536]">
              <button onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0}
                className="text-[12px] text-[#005BB3] dark:text-[#3b82f6] disabled:text-[#6B7280] disabled:opacity-40" style={{ fontFamily: 'var(--font-sans)' }}>&larr; Prev</button>
              <span className="text-[12px] text-[#6B7280]" style={{ fontFamily: 'var(--font-mono)' }}>{page + 1} / {totalPages}</span>
              <button onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))} disabled={page >= totalPages - 1}
                className="text-[12px] text-[#005BB3] dark:text-[#3b82f6] disabled:text-[#6B7280] disabled:opacity-40" style={{ fontFamily: 'var(--font-sans)' }}>Next &rarr;</button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
